module.exports = __webpack_public_path__ + "img/faq.86078962.svg";